import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="border-b border-white/10 sticky top-0 bg-black/80 backdrop-blur-xl z-10">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#D4AF37] transition-colors">
            <ArrowLeft size={16} /> Volver
          </Link>
          <span className="font-display font-bold tracking-[0.2em] uppercase text-xs">
            JordyBT<span className="gold-text">_Fitness</span>
          </span>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display font-bold uppercase text-3xl md:text-4xl mb-2">{title}</h1>
        <p className="text-white/40 text-xs mb-10">Última actualización: {updated}</p>
        <div className="legal-content space-y-6 text-white/70 text-sm md:text-base leading-relaxed">{children}</div>
      </article>
    </div>
  );
}

export const H = ({ children }) => (
  <h2 className="font-display font-semibold uppercase tracking-wide text-lg text-white mt-10 mb-3">{children}</h2>
);
